export enum TripOverviewModalType {
  AccommodationFilters = 'accommodationFilters',
  AddFlights = 'addFlights',
  ChangeTicket = 'changeTicket',
  ContinueWithSuggestedDate = 'continueWithSuggestedDate',
  DestinationSelector = 'destinationSelector',
  EditTrip = 'editTrip',
  ExternalError = 'externalError',
  FerryDetails = 'ferryDetails',
  FerryMultipleVehicles = 'ferryMultipleVehicles',
  FlightDetails = 'flightDetails',
  HomeAirportSelector = 'homeAirportSelector',
  MonthsSelector = 'monthsSelector',
  None = 'none',
  PaxSelector = 'paxSelector',
  PortSelector = 'portSelector',
  PremadeTripDescription = 'premadeTripDescription',
  PriceBreakdown = 'priceBreakdown',
  PriceGuarantee = 'priceGuarantee',
  RemoveDestination = 'removeDestination',
  WhyWeSuggest = 'whyWeSuggest',
}
